class fpSlider extends HTMLElement {
  constructor() {
      super();
  }
  connectedCallback() {
      const slidesPerView = this.dataset.slidesPerView;
    
      this.swiper = new Swiper(this, {
        slidesPerView: 1.2,
        spaceBetween: 5,
        watchSlidesProgress: true,
        mousewheel: {
            forceToAxis: true
        },
        navigation: {
            nextEl: '.fp-next-btn-mob',
            prevEl: '.fp-prev-btn-mob'
        },
        scrollbar: {
            el: '.discover-slider-scrollbar',
            draggable: true
        },
        breakpoints: {
            1011: {
                freeMode: true,
                slidesPerView: slidesPerView,
                spaceBetween: 10,
                centeredSlides: false,
                scrollbar: false,
                navigation: {
                    nextEl: '.fp-next-btn',
                    prevEl: '.fp-prev-btn'
                }
            }
        },
      });
  }
}

function createFpSlider() {
  customElements.define("fp-slider", fpSlider);
}

createFpSlider();

class fcSlider extends HTMLElement {
  constructor() {
      super();
  }
  connectedCallback() {
      const slidesPerView = this.dataset.slidesPerView;
    
      this.swiper = new Swiper(this, {
        slidesPerView: 1.2,
        spaceBetween: 5,
        watchSlidesProgress: true,
        mousewheel: {
            forceToAxis: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            1011: {
                freeMode: true,
                slidesPerView: slidesPerView,
                spaceBetween: 10,
                centeredSlides: false,
                scrollbar: false,
            }
        },
      });
  }
}

function createFcSlider() {
  customElements.define("fc-slider", fcSlider);
}

createFcSlider();

// ========= Custom Redirect  =========
// if (window.location.href.includes('/products/cmt-post-procedure')){
//     console.log('redirect true')
//     window.location.href = "https://revisionskincare.com/pages/cmt-post-procedure-cream"
// }

document.querySelectorAll(".accordion-group").forEach((item) => {
	item.addEventListener("click", function (event) {
		let currentAccordion = event.target.closest(".accordion");
		let currentSummary = event.target.closest(".accordion summary");
		let accordionGroup = event.currentTarget;

		if (!currentSummary) return;
		if (!accordionGroup.contains(currentSummary)) return;

		accordionGroup.querySelectorAll(".accordion").forEach((accordion) => {
			if (accordion != currentAccordion) {
				accordion.removeAttribute("open");
			}
		});
	});
});

document.querySelectorAll(".float-card").forEach((card) => {
	var hammertime = new Hammer(card);

    const swiperSlider = card.closest('.swiper');
    
	hammertime.on("swipeleft", function (ev) {
		card.classList.add("active");
        if(swiperSlider){
            swiperSlider.swiper.autoplay.stop();
        }
	});

	hammertime.on("swiperight", function (ev) {
		card.classList.remove("active");
        if(swiperSlider){
            swiperSlider.swiper.autoplay.start();
        }
	});

    if (window.matchMedia('(max-width: 1010px)').matches) {
        card.addEventListener('click', function(ev){
            if(!card.classList.contains("active")){
                ev.preventDefault();
                card.classList.add("active");
                if(swiperSlider){
                    swiperSlider.swiper.autoplay.stop();
                }
            }
        });
    }


});

function scrolledCheck() {
	if (window.pageYOffset > 0) {
		document.body.classList.add("window-scrolled");
	} else {
		document.body.classList.remove("window-scrolled");
	}
}
scrolledCheck();

window.addEventListener("scroll", scrolledCheck);



// static

function setStaticViewportHeight() {
    const value = window.innerHeight;
    const currentValue = getComputedStyle(document.documentElement).getPropertyValue("--viewport-height-fixed");
    if(value != currentValue){
        document.documentElement.style.setProperty(
            "--viewport-height-fixed",
            `${value}px`
        );
    }
}
function setShortViewportHeight() {
  const value = document.documentElement.clientHeight;
  const currentValue = getComputedStyle(document.documentElement).getPropertyValue("--100-svh");
  if (value != currentValue) {
      document.documentElement.style.setProperty(
          "--100-svh",
          `${value}px`
      );
  }
}




// dynamic

function setViewportHeightUnit() {
    const value = window.innerHeight * 0.01;
    const currentValue = getComputedStyle(document.documentElement).getPropertyValue("--vh");

    if(value != currentValue){
        document.documentElement.style.setProperty("--vh", `${value}px`);
    }
}

function setStaticHeaderTopPosition(){
    const header = document.getElementById("header");

    const value = header.getBoundingClientRect().top;
    const currentValue = getComputedStyle(document.documentElement).getPropertyValue("--header-top-position-fixed");

    if(value != currentValue){
		document.documentElement.style.setProperty(
			"--header-top-position-fixed",
			`${value}px`
		);
    }  
}

function setStaticHeaderBottomPosition(){
    const header = document.getElementById("header");

    const value = header.getBoundingClientRect().bottom;
    const currentValue = getComputedStyle(document.documentElement).getPropertyValue("--header-bottom-position-fixed");

    if(value != currentValue){
		document.documentElement.style.setProperty(
			"--header-bottom-position-fixed",
			`${value}px`
		);
    }  
}


function setHeaderBottomPosition(){
    const header = document.getElementById("header");

    const value = header.getBoundingClientRect().bottom;
    const currentValue = getComputedStyle(document.documentElement).getPropertyValue("--header-bottom-position");

    if(value != currentValue){
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${value}px`
		);
    }
}

function setHeaderTopPosition(){
    const header = document.getElementById("header");

    const value = header.getBoundingClientRect().top;
    const currentValue = getComputedStyle(document.documentElement).getPropertyValue("--header-top-position");

    if(value != currentValue){
		document.documentElement.style.setProperty(
			"--header-top-position",
			`${value}px`
		);
    }  
}

function setHeaderHeight(){
    const header = document.getElementById("header");

    const value = header.getBoundingClientRect().height;
    const currentValue = getComputedStyle(document.documentElement).getPropertyValue("--header-height");

    if(value != currentValue){
		document.documentElement.style.setProperty(
			"--header-height",
			`${value}px`
		);
    }  
}

function setPDPDockHeight(){
    const pdpDock = document.getElementById("pdp-dock");

    if(pdpDock){
        const value = pdpDock.getBoundingClientRect().height;
        const currentValue = getComputedStyle(document.documentElement).getPropertyValue("--pdp-dock-height");
    
        if(value != currentValue){
            document.documentElement.style.setProperty(
                "--pdp-dock-height",
                `${value}px`
            );
        }
    }
}

function setHeaderDrawerWidth() {
	const headerdrawerToggle = document.getElementById("header-drawer-opener");

    const value = headerdrawerToggle.getBoundingClientRect().right;
    const currentValue = getComputedStyle(document.documentElement).getPropertyValue("--header-drawer-width");

    if(value != currentValue){
		document.documentElement.style.setProperty(
			"--header-drawer-width",
			`${value}px`
		);
    }
}


function setCustomPropertiesOnLoad() {

    setShortViewportHeight();
    setStaticViewportHeight();
	setStaticHeaderTopPosition();
    setStaticHeaderBottomPosition();

	setViewportHeightUnit();

    setHeaderTopPosition();
    setHeaderHeight();
    setHeaderBottomPosition();

    setPDPDockHeight();
	setHeaderDrawerWidth();
}

function setCustomPropertiesOnScroll() {
    setHeaderBottomPosition();
    setHeaderTopPosition();
}

function setCustomPropertiesOnResize() {
	setViewportHeightUnit();

}


window.addEventListener("load", setCustomPropertiesOnLoad, false);

window.addEventListener("scroll", debounce(setCustomPropertiesOnScroll, 300), false);

window.addEventListener("resize", debounce(setCustomPropertiesOnResize, 300), false);


function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	).filter((ele) => ele.offsetWidth !== 0 || ele.offsetHeight !== 0);
}

document.querySelectorAll("details summary").forEach((summary) => {
	summary.setAttribute(
		"aria-expanded",
		summary.parentNode.hasAttribute("open")
	);

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	summary.addEventListener("click", (event) => {
		event.currentTarget.setAttribute(
			"aria-expanded",
			!event.currentTarget.closest("details").hasAttribute("open")
		);
	});

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});


function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}


const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
    // console.log(elements);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	if(elementToFocus) {
		elementToFocus.focus();
	}
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
	document.querySelector(":focus-visible");
} catch (e) {
	focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
	const navKeys = [
		"ARROWUP",
		"ARROWDOWN",
		"ARROWLEFT",
		"ARROWRIGHT",
		"TAB",
		"ENTER",
		"SPACE",
		"ESCAPE",
		"HOME",
		"END",
		"PAGEUP",
		"PAGEDOWN",
	];
	let currentFocusedElement = null;
	let mouseClick = null;

	window.addEventListener("keydown", (event) => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = false;
		}
	});

	window.addEventListener("mousedown", (event) => {
		mouseClick = true;
	});

	window.addEventListener(
		"focus",
		() => {
			if (currentFocusedElement)
				currentFocusedElement.classList.remove("focused");

			if (mouseClick) return;

			currentFocusedElement = document.activeElement;
			currentFocusedElement.classList.add("focused");
		},
		true
	);
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
			"*"
		);
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach((video) => {
		if (video.hasAttribute("control") || video.id.includes("vjs")) {
			video.pause();
		}
	});

	document.querySelectorAll("product-model").forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	// if (elementToFocus) elementToFocus?.focus();
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });

		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this))
		);
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this)
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class headerDrawerOpener extends HTMLElement {
	constructor() {
		super();

		this.buttons = this.querySelectorAll(".header-drawer-opener-button");
		this.menuOpeners = Array.from(this.buttons).filter((button) =>
			button.classList.contains("header-drawer-menu-opener")
		);

		if (!this.buttons) return;

		this.buttons.forEach((button) =>{
            button.addEventListener("click", this.onClick.bind(this));
        });

		this.menuOpeners.forEach((menuOpener) => {
            menuOpener.addEventListener("mouseenter", this.onMouseEnter.bind(this));
            menuOpener.addEventListener("mouseleave", this.onMouseLeave.bind(this));
        });


	}

    onClick(event){
        const opener = event.currentTarget;

		if (window.matchMedia('(max-width: 1010px)').matches) {
			this.toggleHeaderDrawer(opener) 
		}else{
			this.openHeaderDrawer(opener);
		}
    }

    onMouseEnter(event){
        const opener = event.currentTarget;
        this.timer = setTimeout(() => {
            // opener.click();
			document.querySelector("#HeaderDrawer").show(opener)
        }, 200);
    }


    onMouseLeave(){
        clearTimeout(this.timer);
    }
	
	// might remove this
	toggleHeaderDrawer(opener) {
		if (this.classList.contains('open')){
			document.querySelector("#HeaderDrawer").close();

		}else{
			document.querySelector("#HeaderDrawer").show(opener);
		}
	}

    openHeaderDrawer(opener){
        document.querySelector("#HeaderDrawer").show(opener);
    }
}
customElements.define("header-drawer-opener", headerDrawerOpener);
class HeaderDrawer extends HTMLElement {
	constructor() {
		super();

        this.menuOpeners = document.querySelectorAll('.header-drawer-menu-opener');
        this.menus = this.querySelectorAll('.header-drawer-menu');

		this.querySelector("#HeaderDrawer-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);

		this.querySelectorAll('.header-drawer-mb-return').forEach((btn) => {
			btn.addEventListener('click', this.closeSubMenu.bind(this) )
		})


		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.close();
		});
		
		this.querySelectorAll('.header-drawer-submenu-opener').forEach((subMenuOpener) => {
			subMenuOpener.addEventListener("mouseenter", this.onSubMenuMouseEnter.bind(this))
			subMenuOpener.addEventListener("click", this.onSubMenuMouseEnter.bind(this))
		})

		this.querySelectorAll('.header-drawer-menu-opener-mb').forEach((menu) => {
			menu.addEventListener("click", this.openMobileSubMenu.bind(this))
		})

		if (window.matchMedia('(min-width: 1011px)').matches) {
			this.querySelector('#HeaderDrawer-Overlay').addEventListener('mouseenter', this.close.bind(this) )
            document.querySelector('.header-sidemenu').addEventListener('mouseenter', this.close.bind(this) )
		}


		

	}

	show(opener) {
        this.openBy = opener;

        this.setAttribute("open", "");
        this.querySelector(".header-drawer-inner").classList.add("active");

        this.menuOpeners.forEach((menuOpener) => {
            menuOpener.classList.remove("active");
        });

        this.menus.forEach((menu) => {
            menu.classList.remove("active");
        });

        document.querySelector(this.openBy.getAttribute("data-menu-opener")).classList.add("active");
        document.querySelector(this.openBy.getAttribute("data-menu")).classList.add("active");

        trapFocus(this, this.querySelector('[role="dialog"]'));
        
        document.body.classList.add("header-drawer-inner-opening", "header-drawer-opening", "overflow-hidden");
		document.querySelector('#header-drawer-opener').classList.add('open')
	}

	close() {
        // after dialog close
		this.querySelector(".header-drawer-inner").addEventListener(
			"transitionend",
			() => {
                // remove active from opener
                this.menuOpeners.forEach((menuOpener) => {
                    menuOpener.classList.remove("active");
                });
                // move focus back to opener
                // removeTrapFocus(this.openBy);
                // close header drawer
                this.removeAttribute("open");
                // remove class from body
                document.body.classList.remove("header-drawer-opening", "overflow-hidden");
			},
			{ once: true }
		);

        // close dialog
        this.querySelector(".header-drawer-inner").classList.remove("active");
        document.body.classList.remove("header-drawer-inner-opening");
		document.querySelector('#header-drawer-opener').classList.remove('open')

		// this.querySelectorAll('.header-mb-submenu').forEach((i) => {
		// 	i.removeAttribute('open')
		// 	i.querySelector('summary').setAttribute('aria-expanded', 'false')
		// })
		this.closeSubMenu()
	}



	closeSubMenu () {
		this.querySelector('.header-drawer-menu-mobile').classList.remove('open')
        this.querySelectorAll('.header-drawer-submenu-opener').forEach((subMenu) => {
            subMenu.classList.remove('active');
        });
        this.querySelectorAll('.header-drawer-submenu').forEach((subMenu) => {
            subMenu.classList.remove('active');
        });
        this.querySelectorAll('.header-drawer-feature-items').forEach((subMenu) => {
            subMenu.classList.remove('active');
        });
	}
	onSubMenuMouseEnter(event){
		const subOpener = event.currentTarget
		let dataMenu = subOpener.getAttribute('data-menu').trim()
		let dataMenuFp = subOpener.getAttribute('data-menu-handle').trim()

		this.querySelectorAll('.header-drawer-submenu').forEach((subMenu) => {
			subMenu.classList.remove('active')
		})

		this.querySelectorAll('.header-drawer-feature-items').forEach((subMenuFp) => {
			subMenuFp.classList.remove('active')
		})

		this.querySelectorAll('.header-drawer-submenu-opener').forEach((subMenuOpener) => {
			subMenuOpener.classList.remove('active')
		})

		this.querySelector(`.header-drawer-submenu[data-menu=${dataMenu}]`).classList.add("active")
		this.querySelector(`.header-drawer-feature-items[data-menu-fp=${dataMenu}]`)?.classList.add("active")
		
		subOpener.classList.add("active")

		
	}
	
	openMobileSubMenu(event) {
		const subOpener = event.currentTarget
		let dataMenu = subOpener.getAttribute('data-menu').trim()

		this.querySelectorAll('.header-drawer-menu-mobile-block').forEach((menu) => {
			menu.classList.remove('active')
		})
		this.querySelector(`.header-drawer-menu-mobile-block[data-menu=${dataMenu}]`).classList.add("active")
		this.querySelector('.header-drawer-menu-mobile').classList.add('open')

	}


}

customElements.define("header-drawer", HeaderDrawer);



class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (!poster) return;
		poster.addEventListener("click", this.loadContent.bind(this));
	}

	loadContent(focus = true) {
		window.pauseAllMedia();
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(true)
			);

			this.setAttribute("loaded", true);
			const deferredElement = this.appendChild(
				content.querySelector("video, model-viewer, iframe")
			);
			if (focus) deferredElement.focus();
		}
	}
}

customElements.define("deferred-media", DeferredMedia);








// Product Scripts

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector("button");

        if (!button) return;
        button.addEventListener("click", () => {
            const modal = document.querySelector(this.getAttribute("data-modal"));
            if (modal) modal.show(button);
        });
    }
}
customElements.define("modal-opener", ModalOpener);
class ModalDialog extends HTMLElement {
    constructor() {
        super();

        this.querySelector('[id^="ModalClose-"]').addEventListener(
            "click",
            this.hide.bind(this, false)
        );

        this.addEventListener("keyup", (event) => {
            if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });

        if (this.classList.contains("media-modal")) {
            this.addEventListener("click", (event) => {
                this.hide();
            });
        } else {
            this.addEventListener("click", (event) => {
                if (event.target === this) this.hide();
            });
        }
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden");
        this.setAttribute("open", "");
        this.querySelector('[role="dialog"]').classList.add("active");
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {

        if (this.querySelector('[role="dialog"]').classList.contains('modal-dialog--animation')) {

            this.querySelector('[role="dialog"]').addEventListener(
                "transitionend",
                () => {
                    window.pauseAllMedia();
                    removeTrapFocus(this.openedBy);
                    this.removeAttribute("open");
                    document.body.classList.remove("overflow-hidden");
                    document.body.dispatchEvent(new CustomEvent("modalClosed"));
                },
                { once: true }
            );

            this.querySelector('[role="dialog"]').classList.remove("active");

        }
        else {

            window.pauseAllMedia();
            removeTrapFocus(this.openedBy);
            this.querySelector('[role="dialog"]').classList.remove("active");
            this.removeAttribute("open");
            document.body.classList.remove("overflow-hidden");
            document.body.dispatchEvent(new CustomEvent("modalClosed"));

        }

    }
}
customElements.define("modal-dialog", ModalDialog);
class ProductModal extends ModalDialog {
    constructor() {
        super();
    }

    hide() {
        super.hide();
    }

    show(opener) {
        super.show(opener);
        this.showActiveMedia();
    }

    showActiveMedia() {
        this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
                "data-media-id"
            )}"])`
        ).forEach((element) => {
            element.classList.remove("active");
        });
        const activeMedia = this.querySelector(
            `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
            ? activeMediaTemplate.content
            : null;
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');

        if (activeMedia.clientWidth > container.clientWidth && activeMedia.clientHeight > container.clientHeight) {
            container.scrollLeft =
                (activeMedia.clientWidth - container.clientWidth) / 2;
            container.scrollTop =
                (activeMedia.clientHeight - container.clientHeight) / 2;
        }

    }
}
customElements.define("product-modal", ProductModal);

class ProductMediaCollage extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.initSlider();
    }

    initSlider() {

        let galleryThumbs = new Swiper('.product-media-thumbs', {
            spaceBetween: 10,
            direction: 'vertical',
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            preventClicks: false,
            preventClicksPropagation: false,
          });
        
        
          this.swiper = new Swiper(this, {
			slidesPerView: 1,
            effect: "fade",
            loop: false,
            speed: 300,
            autoHeight: true,
            draggable: false,
            focusableElements: '.focusDisableSwiper',
            thumbs: {
                swiper: galleryThumbs,
            },

        });


    }

    refresh(variantData) {

        const variantTitle = variantData.title;
        const variantTitleArray = variantTitle.split(' / ');

        const target = this.querySelector('.product-media-collage-tile-list');
        let mediaCounter = 0;
        Array.from(target.children).forEach((item) => {

            const mediaAltLArray = item.dataset.mediaAlt.split(' / ');
            let isMediaAltMatched = true;

            for (const mediaAltItem of mediaAltLArray) {
                if (!variantTitleArray.includes(mediaAltItem)) {
                    isMediaAltMatched = false;
                    break;
                }
            }

            if (item.dataset.variantMedia == "true" && !isMediaAltMatched) {
                item.classList.add('hidden');
            }
            else {
                item.classList.remove('hidden');
                item.querySelector('[data-media-index]').dataset.mediaIndex = mediaCounter;
                mediaCounter++;
            }
        });

    }


}
customElements.define("product-media-collage", ProductMediaCollage);


class ProductMediaSlider extends HTMLElement {
    constructor() {
        super();

        this.swiper = null;
        this.init();
    }

    init() {
        // this.loadContent(this.getDefaultVariantData());
        this.initSlider();
    }

    refresh(variantData) {
        if (this.swiper) {
            this.destroySlider();
        }
        // this.loadContent(variantData);
        this.initSlider();
    }

    initSlider() {

        this.swiper = new Swiper(this, {
			slidesPerView: 1,
			spaceBetween: 6,
            loop: false,
            speed: 400,
            focusableElements: '.focusDisableSwiper',
            pagination: {
                el: '.swiper-pagination--line',
                type: 'bullets',
                bulletClass: 'swiper-pagination-bullet--line',
                bulletActiveClass: 'active'
            },
            on: {

                activeIndexChange: function (swiper) {

                    const currentSlideVideo = swiper.slides[swiper.activeIndex].querySelector('video');
                    const previousSlideVideo = swiper.slides[swiper.previousIndex].querySelector('video');
                    if (previousSlideVideo) {
                        previousSlideVideo.pause();
                    }
                    if (currentSlideVideo) {
                        currentSlideVideo.play();
                    }

                }
            }
        });

    }

    // loadContent(variantData) {
    //     const variantTitle = variantData.title;
    //     const templateContent = this.querySelector('template').content.cloneNode(true);
    //     const target = this.querySelector('.swiper-wrapper');
    //     target.innerHTML = '';
    //     target.append(templateContent);
    //     let counter = 0;
    //     Array.from(target.children).forEach(function (item) {
    //         if (item.dataset.variantMedia == "true" && !variantTitle.includes(item.dataset.mediaAlt)) {
    //             item.remove();
    //         }
    //         else {
    //             item.querySelector('[data-media-index]').dataset.mediaIndex = counter;
    //             counter++;
    //         }
    //     });

    // }

    destroySlider() {
        this.swiper.destroy(true, true);
    }

    getDefaultVariantData() {
        return JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }

}
customElements.define("product-media-slider", ProductMediaSlider);


class ProductSliderModal extends ModalDialog {
    constructor() {
        super();

        this.slider = this.querySelector('.product-zoom-slider');
        this.swiper = null;
        this.init();
    }

    hide() {
        super.hide();
    }

    show(opener) {
        super.show(opener);
        this.showActiveMedia();
    }

    showActiveMedia() {
        const activeMediaIndex = this.openedBy.dataset?.mediaIndex;
        this.swiper.slideTo(activeMediaIndex, 0);
    }

    init() {
        // this.loadContent(this.getDefaultVariantData());
        this.initSlider();
    }

    refresh(variantData) {
        if (this.swiper) {
            this.destroySlider();
        }
        // this.loadContent(variantData);
        this.initSlider();
    }

    initSlider() {

        this.swiper = new Swiper(this.slider, {
            loop: false,
            speed: 400,
            focusableElements: '.focusDisableSwiper',
            navigation: {
                prevEl: ".swiper-nav-button-prev",
                nextEl: ".swiper-nav-button-next",
                disabledClass: "disabled--hidden"
            },
            pagination: {
                el: '.swiper-pagination--fraction',
                type: 'fraction',
            },
            on: {
                activeIndexChange: function (swiper) {

                    const currentSlideVideo = swiper.slides[swiper.activeIndex].querySelector('video');
                    const previousSlideVideo = swiper.slides[swiper.previousIndex].querySelector('video');
                    if (previousSlideVideo) {
                        previousSlideVideo.pause();
                    }
                    if (currentSlideVideo) {
                        currentSlideVideo.play();
                    }

                },
            }
        });

    }

    // loadContent(variantData) {
    //     const variantTitle = variantData.title;
    //     const templateContent = this.querySelector('template').content.cloneNode(true);
    //     console.log(templateContent)
    //     const target = this.querySelector('.swiper-wrapper');
    //     target.innerHTML = '';
    //     target.append(templateContent);
    //     Array.from(target.children).forEach(function (item) {
    //         if (item.dataset.variantMedia == "true" && !variantTitle.includes(item.dataset.mediaAlt)) {
    //             item.remove();
    //         }
    //     });

    // }

    destroySlider() {
        this.swiper.destroy(true, true);
    }

    getDefaultVariantData() {
        return JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }

}
customElements.define("product-slider-modal", ProductSliderModal);

class DetailsModal extends HTMLElement {
    constructor() {
        super();
        this.detailsContainer = this.querySelector('details');
        this.summaryToggle = this.querySelector('summary');

        this.detailsContainer.addEventListener(
            'keyup',
            (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
        );
        this.summaryToggle.addEventListener(
            'click',
            this.onSummaryClick.bind(this)
        );
        this.querySelector('button[type="button"]').addEventListener(
            'click',
            this.close.bind(this)
        );

        this.summaryToggle.setAttribute('role', 'button');
    }

    isOpen() {
        return this.detailsContainer.hasAttribute('open');
    }

    onSummaryClick(event) {
        event.preventDefault();
        event.target.closest('details').hasAttribute('open')
            ? this.close()
            : this.open(event);
    }

    onBodyClick(event) {
        if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
    }

    open(event) {
        this.onBodyClickEvent =
            this.onBodyClickEvent || this.onBodyClick.bind(this);
        event.target.closest('details').setAttribute('open', true);
        document.body.addEventListener('click', this.onBodyClickEvent);
        document.body.classList.add('overflow-hidden');

        trapFocus(
            this.detailsContainer.querySelector('[tabindex="-1"]'),
            this.detailsContainer.querySelector('input:not([type="hidden"])')
        );
    }

    close(focusToggle = true) {
        removeTrapFocus(focusToggle ? this.summaryToggle : null);
        this.detailsContainer.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.body.classList.remove('overflow-hidden');
    }
}
customElements.define("details-modal", DetailsModal);
class DetailsDropdown extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector("details");
        this.content =
            this.mainDetailsToggle.querySelector("summary").nextElementSibling;

        this.mainDetailsToggle.addEventListener(
            "focusout",
            this.onFocusOut.bind(this)
        );
        this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        });
    }

    onToggle() {
        if (!this.animations) this.animations = this.content.getAnimations();

        if (this.mainDetailsToggle.hasAttribute("open")) {
            this.animations.forEach((animation) => animation.play());
        } else {
            this.animations.forEach((animation) => animation.cancel());
        }
    }

    close() {
        this.mainDetailsToggle.removeAttribute("open");
        this.mainDetailsToggle
            .querySelector("summary")
            .setAttribute("aria-expanded", false);
    }
}
customElements.define("details-dropdown", DetailsDropdown);

class ProductMediaGallery extends HTMLElement {
    constructor() {
        super();
    }

}
customElements.define("product-media-gallery", ProductMediaGallery);



class PdpSellingPlan extends HTMLElement {
  constructor() {
      super();

      // Bind the methods to the class instance
      this.updateSellingPlanId = this.updateSellingPlanId.bind(this);
      this.updateSellingPlanFromSelect = this.updateSellingPlanFromSelect.bind(this);
      this.querySelectorAll('.pdp-selling-plan-select').forEach(select => {
          select.addEventListener('click', this.updateState.bind(this));
      });
  }

  connectedCallback() {
      // Ensure this custom element is rendered with its inner content.
      this.render();
      
      // Attach event listeners
      this.addEventListeners();
  }

  render() {
      // You can use this method to define any initial rendering logic if necessary.
      // If the component's markup is rendered dynamically, do it here.
  }

  addEventListeners() {
      // Add event listeners for radio button changes
      const sellingPlanRadios = this.querySelectorAll('.pdp-selling-plan-input-radio');
      sellingPlanRadios.forEach(radio => {
          radio.addEventListener('change', this.updateSellingPlanId);
      });

      // Add event listeners for select element changes (Auto-Replenish)
      const sellingPlanSelects = this.querySelectorAll('.pdp-selling-plan-subsave-select');
      sellingPlanSelects.forEach(select => {
          select.addEventListener('change', this.updateSellingPlanFromSelect);
      });
  }

  updateState(event) {
    event.target.querySelector('input')?.click();

  }


  updateSellingPlanId(event) {
    // Find the product button element
    const productButton = document.querySelector('.pdp-info product-form');
    if (!productButton) return;

    // If "One Time Purchase" is selected, save 'onetime' as the selling plan ID
    if (event.target.value === 'onetime') {
        productButton.removeAttribute('data-selling-plan-id');
    } else if (event.target.value === 'subsave') {
        // If "Auto-Replenish" is selected, get the selected option ID from the corresponding select
        const selectElement = event.target.closest('.pdp-selling-plan-select').querySelector('.pdp-selling-plan-subsave-select');
        const selectedOption = selectElement ? selectElement.options[selectElement.selectedIndex] : null;
        const sellingPlanId = selectedOption ? selectedOption.value : null;

        // Save the selected option's selling plan ID
        if (sellingPlanId) {
            productButton.setAttribute('data-selling-plan-id', sellingPlanId);
        }
    }
}

  updateSellingPlanFromSelect(event) {
      // Get the selected option
      const selectedOption = event.target.options[event.target.selectedIndex];

      // Get the selling_plan.id from the value of the selected option
      const sellingPlanId = selectedOption.value;

      // Find the product button element
      const productButton =  document.querySelector('.pdp-info product-form');

      // Update the data attribute with the selling_plan.id
      if (productButton) {
          productButton.setAttribute('data-selling-plan-id', sellingPlanId);
      }
  }
}

// Define the custom element
customElements.define('pdp-selling-plan', PdpSellingPlan);



class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.removeErrorMessage();
    this.updateMedia();
    this.updateVariantStatuses();
    // this.updateAfterPay();

		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
      this.handleVariantError(true)
		} else {
      this.handleVariantError(false)
      this.updateAfterPay();

			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
			this.updateShareUrl();
      this.updateMedia();

      this.updateTitle()
      this.updateRechargePrice()
		}
    // this.updateTitle()
    // this.updateRechargePrice()

	}

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.variant-pills-select')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updateRechargePrice() {
    console.log(this.currentVariant)
    if(this.currentVariant.selling_plan_allocations){
      console.log('truee')
      document.querySelector('product-form .price-item--recharge-original').innerHTML = `$` + (this.currentVariant.selling_plan_allocations[0]?.price/100).toFixed(2)
    }
  }

  updateTitle() {
    console.log(this.currentVariant, 'variant')
    let selectedTitle = this.querySelector('input[name="variant-Size"]:checked').value
    this.currentVariant.options.forEach((i) => {
        if (selectedTitle == i ){
          let title = document.querySelector('.product-title--main').getAttribute('data-product-title')
          let variantName = i
          document.querySelector('.product-title--main').innerText = title + ' ' + variantName
        }      
    })
    // let title = document.querySelector('.product-title--main').getAttribute('data-product-title')
    // let variantName = this.currentVariant.title
    // document.querySelector('.product-title--main').innerText = title + ' ' + variantName

  }

  updateAfterPay() {
    if(document.querySelector('.pdp-info square-placement')){
      document.querySelectorAll('.pdp-info square-placement').forEach((i) => {
          i.setAttribute('data-amount', `${this.currentVariant.price/100}`)
      })
    }
  }

	updateOptions() {
		// this.options = Array.from(
		// 	this.querySelectorAll("select"),
		// 	(select) => select.value
		// );
    this.options = Array.from(
			this.querySelectorAll("fieldset.variant-pills-select input:checked"),
			(select) => select.value
		);
    console.log('this options', this.options)
	}

	updateMasterId() {
    console.log('variant: ', this.getVariantData().find((variant) => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
		}))
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
		});
	}

	updateMedia() {
        if (!this.currentVariant) return;

        const productGallery = document.getElementById(
          `product-gallery-${this.dataset.section}`
        );
        if (productGallery) productGallery.refresh(this.currentVariant);
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === "false") return;
		window.history.replaceState(
			{},
			"",
			`${this.dataset.url}?variant=${this.currentVariant.id}`
		);
	}

	updateShareUrl() {
		const shareButton = document.getElementById(
			`Share-${this.dataset.section}`
		);
		if (!shareButton || !shareButton.updateUrl) return;
		shareButton.updateUrl(
			`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
		);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-mobile`
		);
    console.log('product forms', productForms)
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}


	removeErrorMessage() {
		const section = this.closest("section");
		if (!section) return;

		const productForm = section.querySelector("product-form");
		if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}`
		)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				const destination = document.querySelector(
					`#price-${this.dataset.section}.price--desktop`
				);
                const destinationMob = document.querySelector(
					`#price-${this.dataset.section}.price--mobile`
				);
				const source = html.querySelector(
					`#price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}.price--desktop`
				);
                console.log('html', html)
                const sourceMob = html.querySelector(
					`#price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}.price--mobile`
				);
				if (source && destination){
                    destination.innerHTML = source.innerHTML;
                } 
				if (sourceMob && destinationMob) destinationMob.innerHTML = sourceMob.innerHTML;

                
				this.toggleAddButton(
					!this.currentVariant.available,
					window.variantStrings.soldOut
				);
			});
	}

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
            `product-form-${this.dataset.section}`
        );
        const productFormMob = document.getElementById(
            `product-form-${this.dataset.section}-mobile`
        );
        if (!productForm) return;
        if (!productFormMob) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonMob = productFormMob.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span:first-of-type > span:first-of-type');
        const addButtonTextMob = productFormMob.querySelector('[name="add"] > span:first-of-type > span:first-of-type');
        if (!addButton) return;
        if (!addButtonMob) return;

        if (disable) {
            addButton.setAttribute("disabled", "disabled");
            addButtonMob.setAttribute("disabled", "disabled");
            if (text) addButtonText.textContent = text;
            if (text) addButtonTextMob.textContent = text;

            productForm.querySelector('quantity-input').classList.add('disable-quantity')
        } else {
            addButton.removeAttribute("disabled");
            addButtonMob.removeAttribute("disabled");
            addButtonText.textContent = window.variantStrings.addToCart;
            addButtonTextMob.textContent = 'ADD';

            productForm.querySelector('quantity-input').classList.remove('disable-quantity')
        }

        if (!modifyClass) return;
    }

  handleVariantError(show_error) {
    if(show_error){
      this.querySelector('.variant-error').classList.remove('hidden')
    }else{
      this.querySelector('.variant-error').classList.add('hidden')
    }
    
  }

	setUnavailable() {
    console.log('UNAVAILABLE!!!', `product-form-${this.dataset.section}`)
		// const button = document.getElementById(
		// 	`product-form-${this.dataset.section}`
		// );
		// const addButton = button.querySelector('[name="add"]');
		// const addButtonText = button.querySelector('[name="add"] > span:first-of-type');
		// const price = document.getElementById(`price-${this.dataset.section}`);
		// if (!addButton) return;
		// addButtonText.textContent = window.variantStrings.unavailable;
		// if (price) price.classList.add("visibility-hidden");
    // console.log('UNAVAILABLE!!')


    
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll("input")).find(
				(radio) => radio.checked
			).value;
		});
	}
}

customElements.define("variant-radios", VariantRadios);

class ProductGallery extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector(".product-gallery-slider");
      this.thumbSlider = this.querySelector(".product-gallery-thumbSlider");
      this.script = this.querySelector('[type="application/json"]');
      this.variantDefaultData = this.getDefaultVariantData();
    }
  
    connectedCallback() {
      this.init();
    }
  
    init() {
      this.loadContent(this.variantDefaultData, this.thumbSlider);
      this.loadContent(this.variantDefaultData, this.slider);
      this.initThumbSlider();
      this.initSlider();
    }
  
    refresh(variantData) {
      if (this.thumbSwiper) {
        this.destroySlider(this.thumbSwiper);
      }
      if (this.sliderSwiper) {
        this.destroySlider(this.sliderSwiper);
      }
      this.loadContent(variantData, this.thumbSlider);
      this.loadContent(variantData, this.slider);
      this.initThumbSlider();
      this.initSlider();
    }
  
    getDefaultVariantData() {
      return JSON.parse(this.script.textContent);
    }
  
    loadContent(variantData, slider) {
      
      this.template = slider.querySelector("template");
      const variantID = variantData.id;
      const templateContent = this.template.content.cloneNode(true);


      const target = slider.querySelector(".swiper-wrapper");
      target.innerHTML = "";
      target.append(templateContent);
      let hasNoVariant = this.getAttribute('data-has-no-variant')
      Array.from(target.children).forEach(function (item) {
        if (item.dataset.variantId != variantID && hasNoVariant == 'false' && item.dataset.variantId != 'gallery-video') {
          item.remove();
        }
      });
    }
  
    initThumbSlider() {
      this.thumbSwiper = new Swiper(this.thumbSlider, {
        direction: "vertical",
        slidesPerView: "auto",
        spaceBetween: 10,
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
        },
        watchSlidesProgress: true,
      });
    }
  
    initSlider() {
      this.sliderSwiper = new Swiper(this.slider, {
        loop: true,
        speed: 400,
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
        },
        focusableElements: ".focusDisableSwiper",
        navigation: {
          prevEl: this.slider.querySelector(".swiper-nav-button--prev"),
          nextEl: this.slider.querySelector(".swiper-nav-button--next"),
          disabledClass: "hidden",
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
          pageUpDown: true,
        },
        pagination: {
          el: this.slider.querySelector(".swiper-pagination"),
          type: "bullets",
          bulletClass: "swiper-pagination-bullet--line",
          bulletActiveClass: "active",
        },
        thumbs: {
          swiper: this.thumbSwiper,
        },
        on: {
          activeIndexChange: function (swiper) {
            const currentSlideVideo =
              swiper.slides[swiper.activeIndex].querySelector("video");
            const previousSlideVideo =
              swiper.slides[swiper.previousIndex].querySelector("video");
            if (previousSlideVideo) {
              previousSlideVideo.pause();
            }
            if (currentSlideVideo) {
              currentSlideVideo.play();
            }
          },
          click: function (swiper, event) {
            if(swiper.clickedSlide.dataset.variantId != 'gallery-video'){
              document.querySelector('product-slider-modal').show('gallery-slider-open')
              document.querySelector('product-slider-modal .swiper-slide img').src = swiper.clickedSlide.querySelector('img').src
            }


          },
        },

      });
    }
  
    destroySlider(swiper) {
      swiper.destroy(true, true);
    }
  }
  customElements.define("product-gallery", ProductGallery);




function validateEmail(inputValue) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	if (re.test(inputValue)){
		return false;
	} else {
		return true;
	}

}

function validatePhone(inputValue) {
  var re = /^(\+1\s?)?(\()?(\d{3})(\))?[\s.-]?(\d{3})[\s.-]?(\d{4})$/;

  if (re.test(inputValue)){
    return false;
  } else {
    return true;
  }
}




// pdp scripts


// document.querySelectorAll('.product-media-thumb-tile').forEach((thumb) => {
// 	thumb.addEventListener('click', () =>{
// 		let sectionId = thumb.getAttribute('data-section-id')
// 		let mediaId = thumb.getAttribute('data-media-id')
// 		let productMedia =  `product-media-collage-tile-${sectionId}-${mediaId}`
//         document.querySelectorAll('.product-media-thumb-tile').forEach(i => {
//             i.classList.remove('active')
//         })
// 		document.getElementById(productMedia).scrollIntoView()
// 	})
// })

// const el = document.querySelectorAll('.product-media-collage-tile')
// const observer = new window.IntersectionObserver(([entry]) => {
//   if (entry.isIntersecting) {
//     console.log('enter')
//     let sectionId = entry.target.getAttribute('data-section-id');
//     let mediaId = entry.target.getAttribute('data-media-id');
//     let productThumbMedia =  `product-media-thumb-tile-${sectionId}-${mediaId}`;
//     document.querySelectorAll('.product-media-thumb-tile').forEach(i => {
//         i.classList.remove('active')
//     })
//     document.getElementById(productThumbMedia).classList.add('active');
//     return
//   }
//   console.log('leave')
// }, {
//   root: null,
//   threshold: 0.6, // set offset 0.1 means trigger if atleast 10% of element in viewport
// })

// el.forEach( i => {
//     observer.observe(i);
// })


// function onGalleryScroll() {
// 	document.querySelectorAll('.product-media-collage-tile').forEach(el => {
// 		let sectionId = el.getAttribute('data-section-id');
// 		let mediaId = el.getAttribute('data-media-id');
// 		let productThumbMedia =  `product-media-thumb-tile-${sectionId}-${mediaId}`;
// 		if (!ScrollTrigger.isInViewport(el, 0.6)){


//             document.getElementById(productThumbMedia).classList.remove('active');

// 		}else{
// 			document.getElementById(productThumbMedia).classList.add('active');
// 		}
// 	})
// }

// onGalleryScroll()
// ScrollTrigger.create({
//     scroller: document.querySelector('.product-media-collage'),
// 	start: 0,
// 	end: "max",
// 	onUpdate: onGalleryScroll
//   });


// Search Modal custom close button functionality - Mobile
const mobileSearchCloseBtn = document.getElementById("mobile-search-modal-close");
const mobileSearchOverlay = document.querySelector(".header-search.mobile-only");
  mobileSearchCloseBtn.addEventListener("click", function(event) {
	event.preventDefault();
	mobileSearchOverlay.classList.remove("shown");
	this.classList.add("hidden");
	document.body.classList.remove("overflow-hidden", "search-dialogue-open");
    var headerSearchInput = document.querySelectorAll('.mobile-only .search__input')[0];
    headerSearchInput.value = "";
  });

// Hide popular products section when search dropdown opens
//   var desktopSearchOpenBtn = document.querySelector(".header-search.desktop-only summary");
//   var desktopSearchInput = document.querySelector(".header-search.desktop-only .field__input");
//   desktopSearchOpenBtn.addEventListener("click", function() {
//     if (desktopSearchOpenBtn.closest("details").getAttribute("open")) {
//         document.querySelector(".popular-results").classList.add("hidden");
//         desktopSearchInput.blur();
//     }
//   });

//  Open mobile search overlay when clicking on grey search button
  const mobileSearchOpenBtn = document.getElementById("mobile-search-open");
  const mobileSearchInput = document.querySelector(".mobile-only .search__input.field__input");
  mobileSearchOpenBtn.addEventListener("click", function(event) {
    mobileSearchInput.click();
    document.body.classList.add("search-dialogue-open");
    mobileSearchOverlay.classList.add("shown");
    mobileSearchInput.focus();
  });

function truncateString(str, num) {
	if (str.length <= num) {
		return str
	}
	return str.slice(0, num) + '...'
}



/* ======================== [Plus] Free Gift ======================== */


function createCookie(name,value,hours) {
    if (hours) {
      var date = new Date();
      date.setTime(date.getTime()+(hours*3600*1000));
      var expires = "; expires="+date.toUTCString();
    } else {
      var expires = "";
    }
  
    document.cookie = name+"="+value+expires+"; path=/";
  }
  
  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }
  
  function eraseCookie(name) {   
    document.cookie = name+'=; Max-Age=-99999999;';  
  }
  
$(document).ready(function() {
    window.gifts = window.gifts || [];
    var plus = [];
  
    var freeGiftModalCookie = readCookie('free-gift-prompted'),
        freeGiftCookie = readCookie('free-gift-added'),
        discountCookie = readCookie('discount');
    
    if (discountCookie == null) {
      discountCookie = '';
    }
  
      gifts.forEach(function(item){
        if (item.discountTrigger.toLowerCase() == discountCookie.toLowerCase()) {
          plus = item;
        }
      });
  
      if (plus.discountTrigger != null && plus.discountTrigger != '') {
        var discountMatch = (discountCookie.toLowerCase() == plus.discountTrigger.toLowerCase());
      } else {
        var discountMatch = false;
      }
  
      var cookieExpiry = parseInt(1),
          offerGift = function() {
            // If we haven't added a gift product, show the free gift banner
            if (!freeGiftCookie) {
              $('.plus-free-gift-modal__cart-trigger').css('display', 'block');
            }
  
            // If we haven't seen the modal before, show it
            if (!freeGiftModalCookie) {
              $('#plus-free-gift__trigger' + plus.id).trigger('click');
            }
  
            initializeFreeGiftModal();
          };
  
    // Initialize free gift modal
    function initializeFreeGiftModal() {
      $('#plus-free-gift__trigger'  + plus.id).magnificPopup({
        beforeClose : function() {
          createCookie('free-gift-prompted', true, cookieExpiry);
        }
      });
      
      if ($('#plus-free-gift__trigger'  + plus.id).is(':hidden')) {
        $('.plus-free-gift-banner__button').trigger('click');
      }
    }
  
    // If we have a discount code cookie, update the input
    if (discountCookie != null && discountCookie != '') {
      $('.plus-discount__input').val(discountCookie.toLowerCase());
    }
    // If the cart qualifies and we have a matching discount, offer the gift
    if (plus.cartQualifies && discountMatch) {
      offerGift();
    }else{
      console.log('not qualifying');
    }
  
    // If a new discount code is added, check if we should offer a gift
    $('.plus-discount__submit').on('click touchstart', function() {
      var enteredCode = $(this).siblings('.plus-discount__input').val().toLowerCase();
  
        createCookie('discount', enteredCode, cookieExpiry);
  
        gifts.forEach(function(item){
          if (item.discountTrigger.toLowerCase() == enteredCode.toLowerCase()) {
            plus = item;
          }
        });
    
        // If the entered code matches our offer and the cart qualifies, offer the gift
        // Otherwise show a message that the code has been logged and will apply at checkout
        if (plus.length != 0 && enteredCode.toLowerCase().length != 0 && enteredCode.toLowerCase() == plus.discountTrigger.toLowerCase() && plus.cartQualifies) {
          $('.plus-discount__error_message').addClass('hidden')
          offerGift();
          sessionStorage.setItem('giftCode', enteredCode);
          sessionStorage.setItem('affiliateId', plus.discountAffiliate);
        } else if(plus.cartQualifies == false){
          $('.plus-discount__error_message').removeClass('hidden')
        } else {
          $('.plus-free-gift-modal__cart-trigger').css('display', 'none');
          sessionStorage.removeItem('giftCode');
          sessionStorage.removeItem('affiliateId');
        }
      
      // Save the entered discount code in a cookie so it can at least be passed to checkout
    });
  
    //Open the modal if the cart banner is clicked
    $('.plus-free-gift-modal__cart-trigger a').on('click', function(evt) {
      evt.preventDefault();
      $('#plus-free-gift__trigger' + plus.id).trigger('click');
    });
  
    // Update the variant id on modal select change
    $('.plus-free-gift-modal__variant-select').on('change', function() {
      var variant_id = $(this).val();
      $(this).closest('.plus-free-gift-modal__cart-form').attr('data-variant-id', variant_id);
    });
  
    // If the customer clicks "Cancel", close the modal
    $('#plus-free-gift-modal .plus-free-gift-modal__cancel').click(function() {
      $.magnificPopup.close();
    });
  
    // Add item to cart
    $(document).on('click', '.plus-free-gift-modal__add-to-cart', function(evt) {
        
      var variant_id = $(this).closest('.plus-free-gift-modal__cart-form').attr('data-variant-id');
      var quantity = 1;
      let promo_check = false;
      var enteredCodeCh = $('.plus-discount__submit').siblings('.plus-discount__input').val().toLowerCase();

      let nonFree = $(this).attr('data-non-free')
      let discountPercentage = $(this).attr('data-discount-percentage')
      console.log('DISSCOUNT: ',nonFree, discountPercentage)
      createCookie('gift_product_id', variant_id)
      if($('.promo_code_amount')){
  
        console.log(';found', $('.promo_code_amount').length);
  
        for (let i = 1; i <=  $('.promo_code_amount').length; i++) {
            console.log($('.promo_code_amount-' + i).val().toLowerCase());
            if($('.promo_code_amount-' + i).val().toLowerCase() === enteredCodeCh){
              promo_check = true;
            }
        }
        if(promo_check === true){
          console.log(promo_check);
          removeAllFree();
          addAndRemove(variant_id);
        }
        else{
          removeAllFree();
          setTimeout(() => {
            addFreeProp(variant_id, nonFree, discountPercentage)
          }, 1000);
        } 
      }    
      evt.stopPropagation();
    });
    const productGiftID = readCookie('gift_product_id')
    if(productGiftID){
      if ($(`[data-price-variant-id=${productGiftID}]`).length > 0){
          $(`[data-price-variant-id=${productGiftID}]`).removeClass('hidden')
          let giftPrice = parseFloat($(`[data-price-variant-id=${productGiftID}]`).attr('data-variant-price')).toFixed(2)/100
          let subTotalPrice = parseFloat($('.saso-cart-original-total').text().replace(/\$|,/g, '')).toFixed(2)
          giftAddedTotalPrice = subTotalPrice - giftPrice
          $('.saso-cart-original-total').text(`$${giftAddedTotalPrice.toFixed(2)}`)
      }
  
    }
    function addFreeProp(variant_id, nonFree, discountPercentage){
        let noteData = 'Free GWP'
        if ( nonFree == 'true' || nonFree == true ){
            if( discountPercentage > 0){
                noteData = `GWP ${discountPercentage}%`
            }else{
                noteData = 'GWP'
            }

        }
      let formData = { items: [{ quantity: 1, id: variant_id, properties: { 'Note': noteData } }] };
       fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            return response.json();
          })
          .then(response => {
            // Create cookies so the modal/banner don't show once they've added an item
            createCookie('free-gift-prompted', true, cookieExpiry);
            createCookie('free-gift-added', true, cookieExpiry);
    
            // Close the modal and refresh the page to show new item in the cart
            $.magnificPopup.close();
            location.reload();
          })
          .catch((error) => {
            console.error('Error:', error);
          }); 
    }
    function addAndRemove(variant_id) {
  
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ quantity: 0, id: variant_id }),
      })
        .then((response) => {
          return response.json();
          console.log(response.json());
        })
        .then((response) => {
          console.log(variant_id);
          setTimeout(addFreeProp(variant_id), 500);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  
    function removeAllFree(){
      document.querySelectorAll('[data-gwp-variant-id]')?.forEach(item => {
        console.log(item)
        console.log('Free Variant ID: ', item.getAttribute('data-gwp-variant-id'))
        var itemId = item.getAttribute('data-gwp-variant-id')
  
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ quantity: 0, id: itemId }),
        })
          .then((response) => {
            return response.json();
            console.log(response.json());
          })
          .then((response) => {
            console.log('success');
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      })
    }
    let isCartEmpty = document.querySelector('.cart-main-title').getAttribute('data-cart-empty')
  
    if(isCartEmpty == 'true' &&  document.querySelectorAll('[data-gwp-variant-id]').length){
      removeAllFree()
      location.reload()
    }
  
});

/* ======================== END [Plus] Free Gift ======================== */


// ========= Redirection for collection list page =========
var collectionListBody = document.querySelector("body[data-template='list-collections']");
if (collectionListBody) {
    window.location.href = "/";
}


// ========= Image Gallery Section Slider  =========
var swiperThumb = new Swiper(".image-gallery-thumbs", {
    spaceBetween: 5,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    grabCursor: true,
    breakpoints: {
        768: {
          spaceBetween: 10,
        }
      },
  });
  var swiperMain = new Swiper(".image-gallery-main", {
    spaceBetween: 5,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiperThumb,
    },
    breakpoints: {
        768: {
          spaceBetween: 10,
        }
      },
  });
  var swiperInsta = new Swiper(".instagram-slider", {
    spaceBetween: 5,
    slidesPerView: 1.8,
    grabCursor: true,
    freeMode: true,
    breakpoints: {
      576: {
        slidesPerView: 2.2
      },
      1023: {
        slidesPerView: 3.2
      },
      1400: {
        slidesPerView: 4.2
      }
    }
  });

  // ========= Accordion Module script  =========

    var acc = document.getElementsByClassName("accordion-button");
    var panels = document.getElementsByClassName("accordion-panel ");
    for (var i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            var panel = this.nextElementSibling;
            var isActive = this.classList.contains("active");
            for (var j = 0; j < panels.length; j++) {
                panels[j].style.maxHeight = null;
            }
            for (var k = 0; k < panels.length; k++) {
                acc[k].classList.remove("active");
            }
            if (!isActive) {
                this.classList.add("active");
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }






    // mobile drawer box shadow logic

    const elem = document.querySelector('.header-drawer-mb-links-wrap')

    {
    let prevHeight
    new ResizeObserver(changes => {
        for(const change of changes){
        if(change.contentRect.height === prevHeight) return
        prevHeight = change.contentRect.height


        let screenHeight = screen.height - parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-bottom-position-fixed")) - 105 - 47 - 30
            if (prevHeight > screenHeight) {
                document.querySelector('.header-drawer-bottom-featured-link').classList.add('show-box-shadow')
            }else{
                document.querySelector('.header-drawer-bottom-featured-link').classList.remove('show-box-shadow')
            }
        }
    }).observe(elem)
    }



    class cartUpsell extends HTMLElement {
      constructor() {
          super();
      }
      connectedCallback() {        
          this.swiper = new Swiper(this, {
            slidesPerView: 3,
            spaceBetween: 10,
            watchSlidesProgress: true,
            mousewheel: {
                forceToAxis: true
            },
            navigation: {
                nextEl: '.cartupsell-next-btn-mob',
                prevEl: '.cartupsell-prev-btn-mob'
            },
            breakpoints: {
                1011: {
                    freeMode: true,
                    slidesPerView: 4,
                    spaceBetween: 10,
                    centeredSlides: false,
                    scrollbar: false,
                    navigation: {
                        nextEl: '.cartupsell-next-btn',
                        prevEl: '.cartupsell-prev-btn'
                    }
                }
            },
          });
      }
    }
  customElements.define("cart-upsell", cartUpsell);
